__turbopack_context__.v({
  "dropdown": "multiRangeSlider-module-scss-module__2Tgv1q__dropdown",
  "filterRangeWrapper": "multiRangeSlider-module-scss-module__2Tgv1q__filterRangeWrapper",
  "opened": "multiRangeSlider-module-scss-module__2Tgv1q__opened",
  "priceMax": "multiRangeSlider-module-scss-module__2Tgv1q__priceMax",
  "priceMin": "multiRangeSlider-module-scss-module__2Tgv1q__priceMin",
  "priceRangeWrapper": "multiRangeSlider-module-scss-module__2Tgv1q__priceRangeWrapper",
  "progress": "multiRangeSlider-module-scss-module__2Tgv1q__progress",
  "rangeInputs": "multiRangeSlider-module-scss-module__2Tgv1q__rangeInputs",
  "rangeSlider": "multiRangeSlider-module-scss-module__2Tgv1q__rangeSlider",
  "rangeSliderBody": "multiRangeSlider-module-scss-module__2Tgv1q__rangeSliderBody",
  "rangeSliderHeader": "multiRangeSlider-module-scss-module__2Tgv1q__rangeSliderHeader",
  "title": "multiRangeSlider-module-scss-module__2Tgv1q__title",
});
